// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bfj_a big_tr","StrollerBoxWidget__imageCounselling":"bfj_b big_kg"};